export default __webpack_public_path__ + "static/media/prag_banner_highlight.5ed0449b.png";